import {HttpErrorResponse, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";

@Injectable({
  providedIn: "root"
})
export class AnalyticsPayloadService {
  analyticsError: BehaviorSubject<{ req: HttpRequest<any>; err: HttpErrorResponse }> = new BehaviorSubject({ req: {} as any, err: {} as HttpErrorResponse });
  language: BehaviorSubject<string>;
  province: BehaviorSubject<string>;
  personalization: BehaviorSubject<any>;
  constructor(
  ) {
    this.language = new BehaviorSubject("");
    this.province = new BehaviorSubject("");
    this.personalization = new BehaviorSubject({});
  }

  handleApiErrors(req: HttpRequest<any>, err: HttpErrorResponse) {
    this.analyticsError.next({req, err});
  }
}
